export const docksInitialState = {
    loading: false,
    creating: false,
    photoUpdateInProgress: false,
    dock: {},
    errors: [],
    messages: [],
};
